import MultiCriticalitySubscription from "models/MultiCriticalitySubscription";
import SubscribableStore from "sensoteq-react-core/models/SubscribableStore";

export default class MultiCriticalityStore extends SubscribableStore {
  constructor(rootStore) {
    super(rootStore, MultiCriticalitySubscription);
  }
}
